export default __webpack_public_path__ + "static/media/internet-speedtest.652aef4f.png";